<div class="picker" >
  <color-chrome *ngIf="options.type=='chrome'" [color]="color" (onChangeComplete)="onColorChanged($event.color?.hex)">
  </color-chrome>

  <color-block *ngIf="options.type=='block'" [color]="color" [colors]="options.colors" [triangle]="options.triangle"
    [width]="options.width" (onSwatchHover)="options.onSwatchHover($event.hex,$event.$event)" (onChangeComplete)="onColorChanged($event.color?.hex)"></color-block>
  <color-alpha-picker
  *ngIf="options.type=='alpha'"
  [color]="color"
  [width]="options.width"
  [height]="options.height"
  [direction]="options.direction"

  (onChangeComplete)="onColorChanged($event.color?.hex)"
  ></color-alpha-picker>


  <color-github *ngIf="options.type=='github'" [color]="color" options.colors (onChangeComplete)="onColorChanged($event.color?.hex)"></color-github>
  <color-twitter *ngIf="options.type=='twitter'" [color]="color" options.colors (onChangeComplete)="onColorChanged($event.color?.hex)"></color-twitter>
  <color-hue *ngIf="options.type=='hue'" [color]="color" options.colors (onChangeComplete)="onColorChanged($event.color?.hex)"></color-hue>
  <color-circle *ngIf="options.type=='circle'" [color]="color" options.colors (onChangeComplete)="onColorChanged($event.color?.hex)"></color-circle>
  <color-slider *ngIf="options.type=='slider'" [color]="color" options.colors (onChangeComplete)="onColorChanged($event.color?.hex)"></color-slider>
  <color-material *ngIf="options.type=='material'" [color]="color" options.colors (onChangeComplete)="onColorChanged($event.color?.hex)"></color-material>
  <color-shade-picker *ngIf="options.type=='shade'" [color]="color" options.colors (onChangeComplete)="onColorChanged($event.color?.hex)"></color-shade-picker>
  <color-swatches *ngIf="options.type=='swatches'" [color]="color" options.colors (onChangeComplete)="onColorChanged($event.color?.hex)"></color-swatches>

  <div class="buttons mat-elevation-z4">
    <button class="remove-button" mat-icon-button color="warn" (click)="removeColor()">
      <mat-icon>delete</mat-icon>
    </button>
    <button mat-button (click)="save()">FECHAR</button>
  </div>
</div>
